import { render, staticRenderFns } from "./EndorseButton.vue?vue&type=template&id=1a3198ce&scoped=true&"
import script from "./EndorseButton.vue?vue&type=script&lang=js&"
export * from "./EndorseButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a3198ce",
  null
  
)

export default component.exports